<template>
  <li class="export-wizard-nav-item">
    <a class="side-menu-child" @click.prevent="toggleExportModat">
      <nav-icon :src="iconSrc" :size="16" />
      {{ $t('EXPORT_WIZARD.TITLE') }}
    </a>
    <woot-modal
      :show.sync="showWizard"
      :on-close="closeWizard"
      size="modal-big"
    >
      <export-wizard v-if="showWizard" />
    </woot-modal>
  </li>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import NavIcon from './NavIcon.vue';
import iconSrc from 'dashboard/assets/images/sidebar/export.svg';
import ExportWizard from 'dashboard/components/widgets/ExportWizard/Index.vue';

export default {
  components: { ExportWizard, NavIcon },
  mixins: [clickaway],
  data() {
    return {
      showWizard: false,
      iconSrc,
    };
  },
  methods: {
    toggleExportModat() {
      this.showWizard = !this.showWizard;
    },
    closeWizard() {
      this.showWizard = false;
    },
  },
};
</script>

<style scoped lang="scss">
.export-wizard-nav-item {
  @apply relative flex;
}
</style>
<style lang="scss">
.export-wizard-nav-item .modal-container {
  @apply max-h-[90%];
}
</style>
